<template>
  <div class="order-list-item app-bg" :class="{nopay:order.status === 0}" v-if="order">
   <v-data-table
      :headers="headers"
      hide-actions
      :rows-per-page-items="[10]"
      :items="order"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.policyNo }}</td>
        <td class="text-xs-left"><p style="width:100px;margin-top:12px">{{ props.item.submitTime }}</p></td>
        <td class="text-xs-center">{{ props.item.no }}</td>
        <td class="text-xs-left"><p style="width:200px;margin-top:12px">{{ props.item.applicantName }}</p></td>
        <td class="text-xs-left"><p style="width:100px;margin-top:12px">{{ props.item.productName }}</p></td>
        <td class="text-xs-center">{{ props.item.typeTxt }}</td>
        <td class="text-xs-center">{{ props.item.amounts }}</td>
        <td class="text-xs-center">{{ props.item.payAmounts }}</td>
        <td class="text-xs-left"><p style="width:60px;margin-top:12px">{{ props.item.statusTxt }}</p></td>
        <td class="justify-center td-line-height layout px-0">
          <v-btn color="primary" @click="saveApply(props.item.endorsementCode, props.item.productId)">查看订单</v-btn>
          <v-btn color="primary" class="item-btn" v-if="props.item.status == 0" @click="cancelOrder(props.item)">撤单</v-btn>
          <v-btn color="primary" class="item-btn" :disabled="true" v-if="props.item.invoiceStatus==2||props.item.invoiceStatus==3">{{props.item.invoiceStatus==2?'开票中':'已合并开票'}}</v-btn>
          <v-btn color="primary" v-if="props.item.status == 1&&props.item.typeId == 1&&props.item.invoiceStatus!=2&&props.item.invoiceStatus!=3" @click="downInvoice(props.item)">{{props.item.invoiceStatus==1?'查看发票':'开具发票'}}</v-btn>
          <v-btn color="primary"
                 v-if="props.item.status == 0&&props.item.payStatus == 0&&props.item.typeId == 1&&props.item.payType==0" :loading="payLoading" @click="toPayBefore(props.item)">立即支付</v-btn>
          <v-btn color="primary" v-if="props.item.status == 0&&props.item.payStatus == 0&&props.item.typeId == 1&&props.item.payType==1" :loading="payLoading" @click="toOrder(props.item)">上传支付凭证</v-btn>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="visible" persistent max-width="480px">
        <v-form ref="invoiceForm" lazy-validation class="invoice"  v-if="form.invoiceType == 0">
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>发票类型</label>
            <v-select
                v-model="form.invoiceType"
                :items="typelist"
                placeholder="请选择发票类型"
                :disabled="true"
                :solo="solo"
                label
            ></v-select>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>企业名称</label>
            <v-text-field
                v-model="form.billHead"
                :rules="rules.billHead"
                placeholder="请输入企业名称"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>纳税人识别号</label>
            <v-text-field
                v-model="form.billNo"
                :rules="rules.billNo"
                placeholder="请输入纳税人识别号"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>email</label>
            <v-text-field
                v-model="form.email"
                :disabled="true"
                :rules="rules.email"
                placeholder="请输入email"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
            <p class="introduce-text invoice-status" style="text-align: center">开票金额：{{ form.invoicePrice }}</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px;margin-bottom: 4px">纸质专票在保单生效后于7-14 个工作日内寄送，小规模纳税人不能申请专票</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px">特别提示：单次申请的发票合计开票金额低于500 元的，使用到付方式邮寄</p>
        <div style="text-align:center">
            <v-btn color="primary" :loading="invoiceLoading" @click="makeInvoice">确认开票</v-btn>
            <v-btn color="primary" @click="visible = false">关闭</v-btn>
        </div>
        </v-form>
        <v-form ref="paperForm" lazy-validation class="invoice" v-if="form.invoiceType == 1">
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>发票类型</label>
            <v-select
                v-model="form.invoiceType"
                :items="typelist"
                :disabled="true"
                placeholder="请选择发票类型"
                :solo="solo"
                label
            ></v-select>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>企业名称</label>
            <v-text-field
                v-model="form.billHead"
                :rules="rules.billHead"
                placeholder="请输入企业名称"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>纳税人识别号</label>
            <v-text-field
                v-model="form.billNo"
                :rules="rules.billNo"
                :disabled="true"
                placeholder="请输入纳税人识别号"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>地址</label>
            <v-text-field
                v-model="paperForm.address"
                :rules="rules.address"
                :disabled="true"
                placeholder="请输入地址"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>电话</label>
            <v-text-field
                v-model="paperForm.phone"
                :disabled="true"
                :rules="rules.phone"
                placeholder="请输入电话"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>开户行</label>
            <v-text-field
                v-model="paperForm.bankName"
                :rules="rules.bankName"
                placeholder="请输入开户行"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>账户</label>
            <v-text-field
                v-model="paperForm.bankNo"
                :rules="rules.bankNo"
                placeholder="请输入账户"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>收件公司名称</label>
            <v-text-field
                v-model="paperForm.companyName"
                :rules="rules.companyName"
                placeholder="请输入收件公司名称"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>快递地址</label>
            <v-text-field
                v-model="paperForm.mailAddress"
                :rules="rules.mailAddress"
                :disabled="true"
                placeholder="请输入快递地址"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
         <v-flex class="form-item">
            <label><span class="must-tap">*</span>联系电话</label>
            <v-text-field
                v-model="paperForm.contactPhone"
                :rules="rules.contactPhone"
                placeholder="请输入联系电话"
                :disabled="true"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
            <label><span class="must-tap">*</span>联系人姓名</label>
            <v-text-field
                v-model="paperForm.contactName"
                :rules="rules.contactName"
                :disabled="true"
                placeholder="请输入联系人姓名"
                :solo="solo"
                label
            ></v-text-field>
        </v-flex>
            <p class="introduce-text invoice-status" style="text-align: center">开票金额：{{ form.invoicePrice }}</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px;margin-bottom: 4px">纸质专票在保单生效后于7-14 个工作日内寄送，小规模纳税人不能申请专票</p>
            <p class="introduce-text invoice-status" style="text-align: left;font-size: 12px">特别提示：单次申请的发票合计开票金额低于500 元的，使用到付方式邮寄</p>
        <div style="text-align:center">
            <v-btn color="primary" v-if="showInvoice" :loading="invoiceLoading" @click="makeInvoice">确认开票</v-btn>
            <v-btn color="primary" @click="visible = false">关闭</v-btn>
        </div>
        </v-form>
    </v-dialog>

    <v-dialog v-model="cancerlSync" max-width="290">
      <v-card>
        <v-card-title class="headline">提示</v-card-title>
        <v-card-text> 是否撤销当前订单？ </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat="flat"
            @click="sureCancel"
          >确定</v-btn>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="cancerlSync = false"
          >取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CompanyAccountDetail
              :companyName="applicantName"
              :orderCode="endorsementCode"
              v-model="isCompanyPay"
              :policySaveObj="policySaveObj"
              policyType="endorsement"
              @submitCompany="toPay"
    />
  </div>
</template>

<script>
import validate from "@/assets/js/validate";
import CompanyAccountDetail from "../../insure/components/CompanyAccountDetail";
export default {
  components: {
      CompanyAccountDetail,
  },
  props: {
    order: Array
  },
  data() {
    return {
      orderParam:{},
      showInvoice:true,
      payLoading:false,
      cancerlSync:false,
      insureLoading:false,
      invoiceLoading:false,
      solo:true,
      visible:false,
      form:{
        invoiceType:'0',
        enterpriseFlag:'1',
        appPhone:'',
        billHead:"",
        billNo:'',
        companyCode:'',
        email:'',
        policyCode:'',
        orderCode:"",
        invoicePrice: 0,
        policyNo:""
      },
      paperForm:{
        address:"",
        phone:"",
        bankName:"",
        bankNo:"",
        companyName:"",
        mailAddress:"",
        contactPhone:"",
        contactName:"",
      },
      typelist:[{text:'电子发票',value:0},{text:'纸质增值税专用发票',value:1}],
      rules: {
        billHead: [(v) => !!v || "请输入企业名称"],
        billNo: [(v) => !!v || "请输入纳税人识别号"],
        // appPhone: [(v) => !!v || "请输入联系人电话"],
        address:[(v)=>!!v||"请输入地址"],
        phone:[
           v => {
            if (!v) {
              return "请输入联系电话";
            }
            if (!validate.isTelephone(v) && !validate.isMobilePhone(v)) {
              return "请输入正确的联系电话";
            }
            return true;
          }
        ],
        bankName:[(v)=>!!v||"请输入开户行"],
        bankNo:[(v)=>!!v||"请输入银行卡号"],
        companyName:[(v)=>!!v||"请输入公司名称"],
        mailAddress:[(v)=>!!v||"请输入快递地址"],
        contactPhone:[
           v => {
            if (!v) {
              return "请输入联系电话";
            }
            if (!validate.isTelephone(v) && !validate.isMobilePhone(v)) {
              return "请输入正确的联系电话";
            }
            return true;
          }
        ],
        contactName:[(v)=>!!v||"请输入联系人"],
        email: [(v) => !!v || "请输入email"],
      },
      headers: [
          { text: '保单号', value: 'policyNo', sortable: false,width: '200px'},
          { text: '保全申请日期', value: 'submitTime',sortable: false,width: '200px'},
          { text: '保全号', value: 'no',sortable: false , width: '200px'},
          { text: '投保人', value: 'applicantName',sortable: false , width: '200px'},
          { text: '产品名称', value: 'productName',sortable: false , width: '200px'},
          { text: '保全类型', value: 'typeId',sortable: false ,width: '200px' },
          { text: '保全保费', value: 'amounts',sortable: false , width: '200px'},
          { text: '实付保全保费', value: 'payAmounts',sortable: false ,width: '200px' },
          { text: '状态', value: 'status',sortable: false,width: '200px'},
          { text: '操作',sortable: false, width: '200px'},
        ],
        insureList:[],
        //支付前确认信息
        isCompanyPay:false,
        policySaveObj:{},
        endorsementCode:"",
        applicantName:"",
    };
  },
  computed: {
    time() {
      if (this.order.submitTime) {
        return this.$miment(this.order.submitTime).format("YYYY年MM月DD日 hh:mm");
      }
      return "xxxx年xx月xx日 xx:xx";
    },
    status() {
      if (this.order.status === 1) {
        return "已出单";
      } else if (this.order.status === 0) {
        return "待支付";
      } else if(this.order.status === 5){
        return "已失效";
      }
      return "未知";
    }
  },
  methods: {
    saveApply(orderCode, productId){
      this.$router.push({
        path:'/orderInsure/insureApply/'+orderCode,
        query:{
          productId:productId
        }
      })
    },
    cancelOrder(param){
      this.cancerlSync = true;
      this.orderParam = param
    },
    sureCancel(){
      //撤单
      this.$axios.get('/app/api/heshunbao/cancelEndorsement?endorsementCode='+this.orderParam.endorsementCode).then(res=>{
        this.$message.success(res.message);
        this.$router.go(0);
        this.cancerlSync = false;
      })
    },
    checkOrder(orderCode,productId){
      this.$router.push({
        path:'/orderInsure/detail/'+orderCode,
        query:{
          productId:productId
        }
      });
    },
    toPayBefore(item){
        this.endorsementCode = item.endorsementCode;
        this.policySaveObj = item;
        this.applicantName = item.applicantName;
        this.isCompanyPay = true;
    },
    toPay(item) {
      this.payLoading = true
      this.$axios.get('/app/api/heshunbao/getEndorsementPayUrl?endorsementCode='+item.endorsementCode).then(res=>{
        if(res.data){
          this.payLoading = false
          window.location.href = res.data
        }
      }).catch((val)=>{
        this.payLoading = false
        this.$message.error(val.message)
      })
    },
    toOrder(item){
      this.$router.push({
        path:'/insure/downPay',
        query:{
          param:window.btoa(JSON.stringify({orderCode:item.endorsementCode,amount:item.amounts,from:'bq'}))
        }
      })
    },
    downInvoice(item){
      this.showInvoice = true
      if(item.invoiceStatus==1&&item.invoiceUrl){
        window.open(item.invoiceUrl)
      }else{
        this.visible = true;
        if(item.invoiceStatus == 1){this.showInvoice = false};
        this.invoiceLoading = true;
        this.$axios.get('/app/api/heshunbao/invoiceEndorInfo?endorsementCode='+item.endorsementCode).then(res=>{
          this.form.invoiceType = res.data.invoiceType-1;
          this.form.billHead = res.data.billHead;
          this.form.billNo = res.data.billNo;
          this.form.email = res.data.email;
          this.form.invoicePrice = res.data.invoicePrice;
          this.form.policyNo = res.data.policyNo;
          this.form.endorsementNo = res.data.endorsementNo;
          this.paperForm.address = res.data.address;
          this.paperForm.phone = res.data.phone;
          this.paperForm.bankName = res.data.bankName;
          this.paperForm.bankNo = res.data.bankNo;
          this.paperForm.companyName = res.data.companyName;
          this.paperForm.mailAddress = res.data.mailAddress;
          this.paperForm.contactPhone = res.data.contactPhone;
          this.paperForm.contactName = res.data.contactName;
          this.invoiceLoading = false;
        }).catch(()=>{
          this.invoiceLoading = false;
        })
      }
    },
    orderDown(){
      this.insureLoading = true
      const elink = document.createElement("a");
      elink.style.display = "none";
      elink.href = process.env.VUE_APP_API_URL+'/app/api/heshunbao/downloadPolicy?orderCode='+this.order.orderCode;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      this.$axios.get('/app/api/heshunbao/downloadPolicy?orderCode='+this.order.orderCode).then(()=>{
          this.insureLoading = false
      }).catch(()=>{
          this.insureLoading = false
      })
    },
    makeInvoice(){
      if(this.form.invoiceType == 0){
      if (this.$refs.invoiceForm.validate()) {
        this.invoiceLoading = true
        this.$axios.post('/app/api/heshunbao/makeInvoice',this.form).then(res=>{
          if(res.code == 200){
              this.$emit('update',true)
              if(res.data.invoiceUrl){
                window.open(res.data.invoiceUrl)
                this.visible = false
              }else{
                this.$message.success(res.data.message)
                this.visible = false
            }
          }
        }).catch((val)=>{
            this.$message.error(val.message)
            this.invoiceLoading = false
        })
      }
      }else{
         if (this.$refs.paperForm.validate()) {
          this.invoiceLoading = true
          const {billHead,billNo,invoicePrice,policyNo,endorsementNo} = this.form
          let param = {
            billHead,
            billNo,
            invoicePrice,
            policyNo,
            endorsementNo,
            ...this.paperForm
          }
           this.$axios.post('/app/api/heshunbao/makeSpecialInvoice',param).then(res=>{
              if(res.code == 200){
                this.visible = false
                this.$emit('update',true)
                this.$message.success(res.message)
              }
              this.invoiceLoading = false
          }).catch((val)=>{
              this.$message.error(val.message)
              this.invoiceLoading = false
          })
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
$nopay-color: #fb7282;
.invoice-status{
    color: $primary-color;
}
.invoice{
    background-color: #fff;
    padding: 30px;
    .form-item{
        label{
            width: 100px;
        }
    }
}
.must-tap {
          color: red;
          margin-right: 3px;
        }
.order-list-item {
  margin-top: 20px;
  border: 1px solid #cccccc;
  font-size: 14px;
  &.nopay {
    border-color: $nopay-color;
    .item-header {
      background-color: #fffafb;
      border-bottom: 1px solid $nopay-color;
    }
  }
  .item-header {
    padding: 18px 30px;
    background-color: #fcfcfc;
    border-bottom: 1px solid #cccccc;
    .time {
      color: #666666;
    }
  }
  .item-content {
    padding: 14px 30px;
    .item-btn {
      border: 0.5px solid #979797;
      width: 110px;
      height: 34px;
    }
    .item-table {
      .td-key {
        color: $font-color3;
      }
      .td-value {
        padding: 2px 40px 2px 15px;
      }
    }
  }
}
</style>

